import listActions from 'src/modules/notificacion/list/notificacionListActions';
import NotificacionService from 'src/modules/notificacion/notificacionService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/history';
import Message from 'src/view/shared/message';

const prefix = 'NOTIFICACION_DESTROY';

const notificacionDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: notificacionDestroyActions.DESTROY_STARTED,
      });

      await NotificacionService.destroyAll([id]);

      dispatch({
        type: notificacionDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.notificacion.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/notificacion');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: notificacionDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: notificacionDestroyActions.DESTROY_ALL_STARTED,
      });

      await NotificacionService.destroyAll(ids);

      dispatch({
        type: notificacionDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.notificacion.destroyAll.success'),
      );

      getHistory().push('/notificacion');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: notificacionDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default notificacionDestroyActions;
